/*

Auswahl für Fußsets, gruppiert nach Modellen

erstes Modell
 __________
|          |   ( ) erste Variante       ( ) fünfte Variante
|   Bild   |   (o) zweite Variante      ( ) sechste Variante
|          |   ( ) dritte Variante      ( ) siebte Variante
|__________|   ( ) vierte Variante

zweites Modell
 __________
|          |   ( ) erste Variante       ( ) fünfte Variante
|   Bild   |   ( ) zweite Variante      ( ) sechste Variante
|          |   ( ) dritte Variante      ( ) siebte Variante
|__________|   ( ) vierte Variante

*/

import {formatPrice} from './helpers/general.js'
import './RadioGrouped.css'
import {Trans} from "@lingui/macro";

function RadioGrouped({name, options, selected, onChange, restrictions}) {

    return (
        <div className="radioGrouped" key={name} id={name}>
            {Object.keys(options).map((group, i) => (
                <section className='group empty' key={i} id={name + '_' + i}>
                    <h3><div>{options[group].name}</div></h3>
                    {options[group].img ? <img src={options[group].img} className='img' /> : ''}
                    <div className="actions">
                        {options[group].description ? <div className='description'>{options[group].description}</div> : ''}
                        {Object.keys(options[group].variants).map((variant, j) => (
                            <label key={j} className={(restrictions && restrictions[options[group].variants[variant].key]) ? ' disabled' : ''}>
                                {(restrictions && restrictions[options[group].variants[variant].key]) ? <div className="tooltip"><Trans>nicht kombinierbar mit</Trans> {restrictions[options[group].variants[variant].key]}</div> : ''}
                                <input type='radio' className='radio' name={name} value={options[group].variants[variant].key} checked={selected === options[group].variants[variant].key} onChange={e => onChange(e.target.name, e.target.value)} disabled={(restrictions && restrictions[options[group].variants[variant].key]) ? true : false} />
                                {options[group].variants[variant].name} <div className="price">{formatPrice(options[group].variants[variant].price)}</div>
                                {setTimeout(function()
                                    {
                                        if (!restrictions || !restrictions[options[group].variants[variant].key]) {
                                            document.getElementById(name + '_' + i).classList.remove("empty")
                                        }
                                    }
                                ) && ''}
                            </label>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    )

}

export default RadioGrouped
